<template>
    <div class="container">
        <div class="row flex-lg-row-reverse">
            <input type="hidden" name="_token" value="5pCHlgI9PoI6hnO74qX2ksU8TGCfEZSl6orDbjLP">
<!--            <div class="col-lg-4 pr-0 user-info-wrapp">-->
<!--                <userInfo/>-->
<!--                <p class="tip">Тут відображається інформація, яку ви можете редагувати зліва</p>-->
<!--            </div>-->
            <div v-if="$store.getters.USER.organizationId" class="col-lg-12 user-form pl-0">
                <ProfileBanker/>
            </div>
            <div v-else class="col-lg-12 user-form pl-0">
                <profileInfo/>
            </div>
        </div>
    </div>
</template>

<script>
import profileInfo from '@/components/app/profile/profileInfo.vue';
import userInfo from '@/components/app/profile/userInfo.vue';
import ProfileBanker from '@/components/app/ProfileBanker.vue';

export default {
  components: { ProfileBanker, userInfo, profileInfo },
};
</script>
